// Per spec/blocks.md §2. Small date label shown above the first content
// section. Composes the Text primitive (sm size + text-secondary color)
// in a single-cell table row always left-aligned (P-037.16 D-116 — the
// `alignment` enum was dropped from the schema; chapter convention is
// uniformly left-aligned).
//
// Date is required (`z.string().min(1)`); no `autoHide` callback. The
// outer cell carries 30 px L/R padding only — top/bottom inter-Block
// rhythm lives on the system-level spacer (`src/render/block-padding.
// ts`) per P-037.29 D-137 §item 2. The registry's META override for
// `issue-date` is `{top: 30, bottom: 30}` symmetric — Header → Issue-
// date gap = 30 + 30 = 60 px breathing room from the header's IMG
// bottom.

import { z } from 'zod'
import { defineBlock } from '../render/define-block'
import { html } from '../render'
import { tokens } from '../tokens'
import { text } from '../primitives/text'

const optionsSchema = z.object({})

const inputsSchema = z.object({
  date: z.string().min(1),
})

export const issueDate = defineBlock({
  id: 'issue-date',
  label: 'Issue Date',
  category: 'meta',
  optionsSchema,
  inputsSchema,
  defaultOptions: {},
  defaultInputs: { date: 'March 2026' },
  render: ({ inputs }) => {
    const dateHtml = text({
      text: inputs.date,
      size: tokens.type.size.sm,
      color: tokens.color['text-secondary'],
      align: 'left',
    })
    // prettier-ignore
    return html`<table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%"><tr><td align="left" style="padding: 0 30px;">${dateHtml}</td></tr></table>`
  },
})
